'use client';

import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["options", "placeholder", "open", "keepOpenOnSelect", "className", "dropdownContentClassName", "disabled", "size", "removePortal", "onOpenChange", "defaultSelected", "onSearch", "loading", "searchProps", "hasMore", "onSearchMore"];
import React, { useState } from 'react';
import { useTranslation } from '@crehana/i18n';
import locales from "../../i18n";
import { PrimitiveDropdown, PrimitiveDropdownApiEmpty, PrimitiveDropdownApiSearch, PrimitiveDropdownContent, PrimitiveDropdownList, PrimitiveDropdownLoading, PrimitiveDropdownTrigger, PrimitiveDropdownValueButton } from "../../primitive-dropdown/primitive-dropdown";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function AsyncGenericDropdown(_ref) {
  var _otherProps$selected2, _otherProps$customTri2;
  var options = _ref.options,
    placeholder = _ref.placeholder,
    controlledOpen = _ref.open,
    keepOpenOnSelect = _ref.keepOpenOnSelect,
    className = _ref.className,
    dropdownContentClassName = _ref.dropdownContentClassName,
    disabled = _ref.disabled,
    size = _ref.size,
    removePortal = _ref.removePortal,
    controlledOnOpenChange = _ref.onOpenChange,
    _ref$defaultSelected = _ref.defaultSelected,
    defaultSelected = _ref$defaultSelected === void 0 ? [] : _ref$defaultSelected,
    onSearch = _ref.onSearch,
    loading = _ref.loading,
    searchProps = _ref.searchProps,
    hasMore = _ref.hasMore,
    onSearchMore = _ref.onSearchMore,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    uncontrolledOpen = _useState2[0],
    setUncontrolledOpen = _useState2[1];
  var onOpenChange = controlledOnOpenChange !== null && controlledOnOpenChange !== void 0 ? controlledOnOpenChange : setUncontrolledOpen;
  var _useState3 = useState(Array.isArray(defaultSelected) ? defaultSelected : [defaultSelected]),
    _useState4 = _slicedToArray(_useState3, 2),
    uncontrolledValues = _useState4[0],
    setUncontrolledValues = _useState4[1];
  var open = controlledOpen !== null && controlledOpen !== void 0 ? controlledOpen : uncontrolledOpen;
  var handleOpenChange = function handleOpenChange(open) {
    onSearch('');
    onOpenChange(open);
  };
  if (!otherProps.multiselect) {
    var _otherProps$selected, _otherProps$customTri;
    var selectedValue = (_otherProps$selected = otherProps.selected) !== null && _otherProps$selected !== void 0 ? _otherProps$selected : uncontrolledValues.at(0);
    var allowDeselect = otherProps.allowDeselect,
      controlledOnSelected = otherProps.onSelect;
    return /*#__PURE__*/_jsxs(PrimitiveDropdown, {
      open: open,
      onOpenChange: handleOpenChange,
      children: [/*#__PURE__*/_jsx(PrimitiveDropdownTrigger, {
        asChild: true,
        children: (_otherProps$customTri = otherProps.customTriggerButton) !== null && _otherProps$customTri !== void 0 ? _otherProps$customTri : /*#__PURE__*/_jsx(PrimitiveDropdownValueButton, {
          className: className,
          size: size,
          disabled: disabled,
          open: open,
          placeholder: placeholder,
          value: selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.label
        })
      }), /*#__PURE__*/_jsxs(PrimitiveDropdownContent, {
        removePadding: true,
        removePortal: removePortal,
        className: dropdownContentClassName,
        children: [/*#__PURE__*/_jsx(SearchComponents, {
          options: options,
          onSearch: onSearch,
          loading: loading,
          searchProps: searchProps
        }), loading ? /*#__PURE__*/_jsx(PrimitiveDropdownLoading, {
          loading: loading
        }) : /*#__PURE__*/_jsx(PrimitiveDropdownList, {
          children: options.map(function (_ref2, index) {
            var Element = _ref2.element,
              value = _ref2.value,
              label = _ref2.label;
            var ListElement = /*#__PURE__*/_jsx(Element, {
              disabled: disabled,
              selected: (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value) === value,
              value: value,
              onSelect: function onSelect() {
                if (!keepOpenOnSelect) handleOpenChange(false);
                var valueToPropagate = allowDeselect && (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value) === value ? undefined : {
                  value: value,
                  label: label
                };
                if (controlledOnSelected) {
                  if (allowDeselect) controlledOnSelected(valueToPropagate);
                  if (!allowDeselect && valueToPropagate) {
                    controlledOnSelected(valueToPropagate);
                  }
                }
                setUncontrolledValues(valueToPropagate ? [valueToPropagate] : []);
              }
            }, value);
            return options.length - 1 === index && onSearchMore && hasMore ? /*#__PURE__*/_jsx(FetchMoreTrigger, {
              onSearchMore: onSearchMore,
              children: ListElement
            }) : ListElement;
          })
        })]
      })]
    });
  }
  var values = (_otherProps$selected2 = otherProps.selected) !== null && _otherProps$selected2 !== void 0 ? _otherProps$selected2 : uncontrolledValues;
  return /*#__PURE__*/_jsxs(PrimitiveDropdown, {
    open: open,
    onOpenChange: handleOpenChange,
    children: [/*#__PURE__*/_jsx(PrimitiveDropdownTrigger, {
      asChild: true,
      children: (_otherProps$customTri2 = otherProps.customTriggerButton) !== null && _otherProps$customTri2 !== void 0 ? _otherProps$customTri2 : /*#__PURE__*/_jsx(PrimitiveDropdownValueButton, {
        className: className,
        size: size,
        disabled: disabled,
        open: open,
        placeholder: placeholder,
        value: values.map(function (value) {
          return value.label;
        }).join(', ')
      })
    }), /*#__PURE__*/_jsxs(PrimitiveDropdownContent, {
      removePadding: true,
      removePortal: removePortal,
      className: dropdownContentClassName,
      children: [/*#__PURE__*/_jsx(SearchComponents, {
        options: options,
        onSearch: onSearch,
        loading: loading,
        searchProps: searchProps
      }), loading ? /*#__PURE__*/_jsx(PrimitiveDropdownLoading, {
        loading: loading
      }) : /*#__PURE__*/_jsx(PrimitiveDropdownList, {
        children: options.map(function (_ref3, index) {
          var Element = _ref3.element,
            value = _ref3.value,
            label = _ref3.label;
          var ListElement = /*#__PURE__*/_jsx(Element, {
            disabled: disabled,
            selected: !!values.find(function (selected) {
              return selected.value === value;
            }),
            value: value,
            onSelect: function onSelect() {
              var valuesToPropagate = !!values.find(function (selected) {
                return selected.value === value;
              }) ? values.filter(function (selected) {
                return selected.value !== value;
              }) : [].concat(_toConsumableArray(values), [{
                value: value,
                label: label
              }]);
              if (otherProps.onSelect) {
                otherProps.onSelect(valuesToPropagate);
              }
              setUncontrolledValues(valuesToPropagate);
            }
          }, value);
          return options.length - 1 === index && onSearchMore && hasMore ? /*#__PURE__*/_jsx(FetchMoreTrigger, {
            onSearchMore: onSearchMore,
            children: ListElement
          }) : ListElement;
        })
      })]
    })]
  });
}
function SearchComponents(_ref4) {
  var _searchProps$searchPl, _searchProps$noFoundP, _searchProps$noFoundP2;
  var loading = _ref4.loading,
    onSearch = _ref4.onSearch,
    options = _ref4.options,
    searchProps = _ref4.searchProps;
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  var searchPlaceholder = (_searchProps$searchPl = searchProps === null || searchProps === void 0 ? void 0 : searchProps.searchPlaceholder) !== null && _searchProps$searchPl !== void 0 ? _searchProps$searchPl : locales[languageCode].DROPDOWN_SEARCH_PLACEHOLDER;
  var emptyViewTitle = (_searchProps$noFoundP = searchProps === null || searchProps === void 0 ? void 0 : searchProps.noFoundPlaceholderTitle) !== null && _searchProps$noFoundP !== void 0 ? _searchProps$noFoundP : locales[languageCode].DROPDOWN_EMPTY_TITLE;
  var emptyViewSubtitle = (_searchProps$noFoundP2 = searchProps === null || searchProps === void 0 ? void 0 : searchProps.noFoundPlaceholderSubtitle) !== null && _searchProps$noFoundP2 !== void 0 ? _searchProps$noFoundP2 : locales[languageCode].DROPDOWN_EMPTY_SUBTITLE;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PrimitiveDropdownApiSearch, {
      placeholder: searchPlaceholder,
      onSearch: onSearch
    }), !loading && options.length === 0 && /*#__PURE__*/_jsx(PrimitiveDropdownApiEmpty, {
      title: emptyViewTitle,
      subtitle: emptyViewSubtitle
    })]
  });
}
function FetchMoreTrigger(_ref5) {
  var onSearchMore = _ref5.onSearchMore,
    children = _ref5.children;
  var fetchMoreRef = React.useRef(null);
  React.useEffect(function () {
    if (!fetchMoreRef.current) {
      return;
    }

    // check if fetchMoreRef is visible with intersection observer
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        onSearchMore();
      }
    });
    observer.observe(fetchMoreRef.current);
    return function () {
      observer.disconnect();
    };
  }, [fetchMoreRef, onSearchMore]);
  return /*#__PURE__*/_jsx("div", {
    ref: fetchMoreRef,
    children: children
  });
}